import { Search, Filter } from 'lucide-react'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

const STATUS_OPTIONS: { value: string; label: string }[] = [
  { value: 'all', label: 'All Statuses' },
  { value: 'true', label: 'Active' },
  { value: 'false', label: 'Inactive' },
]

interface CalendarsFiltersProps {
  searchInput: string
  onSearchChange: (value: string) => void
  isActiveFilter: boolean | undefined
  onIsActiveFilterChange: (value: boolean | undefined) => void
}

export function CalendarsFilters({
  searchInput,
  onSearchChange,
  isActiveFilter,
  onIsActiveFilterChange,
}: CalendarsFiltersProps) {
  const selectValue =
    isActiveFilter === undefined ? 'all' : String(isActiveFilter)

  const handleStatusChange = (value: string) => {
    if (value === 'all') {
      onIsActiveFilterChange(undefined)
    } else {
      onIsActiveFilterChange(value === 'true')
    }
  }

  return (
    <div className="flex items-center gap-3 rounded-lg border border-border bg-card p-3">
      {/* Search Input */}
      <div className="relative flex-1 max-w-[352px]">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder="Search calendars..."
          value={searchInput}
          onChange={e => onSearchChange(e.target.value)}
          className="pl-9 bg-muted/50"
        />
      </div>

      {/* Filter Icon */}
      <Filter className="h-6 w-6 text-muted-foreground" />

      {/* Active Status Filter */}
      <Select value={selectValue} onValueChange={handleStatusChange}>
        <SelectTrigger className="w-[150px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {STATUS_OPTIONS.map(option => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
